import React, { useState, useEffect, forwardRef, useImperativeHandle } from 'react';

const CalcularParcelas = forwardRef(({ totalCompraProp }, ref) => {
  const [totalCompra, setTotalCompra] = useState(totalCompraProp || 0);
  const [diasParcelas, setDiasParcelas] = useState('');
  const [resultado, setResultado] = useState([]);
  const [observacaoEditavel, setObservacaoEditavel] = useState('');


  useImperativeHandle(ref, () => ({
    getParcelas: () => {
      return resultado;
    },
    getValores: (parceArray) => {
      console.log('array de parcelas', parceArray);
      setResultado(parceArray);
    }
  }), [resultado]);

  useEffect(() => {
    setTotalCompra(totalCompraProp);
    setResultado([]); // Limpar as parcelas ao atualizar totalCompraProp
  }, [totalCompraProp]);

  const calcularParcelas = () => {
    if (isNaN(parseFloat(totalCompra))) {
      console.error('O valor total da compra não é válido.');
      return;
    }

    const total = parseFloat(totalCompra);
    const diasArray = diasParcelas.split(',').map((dias) => parseInt(dias.trim()));

    const hoje = new Date();
    const parcelas = [];

    diasArray.forEach((dias, index) => {
      const dataVencimento = new Date(hoje);
      dataVencimento.setDate(hoje.getDate() + dias);

      const valorParcela = total / diasArray.length;

      parcelas.push({
        numero: index + 1,
        dataVencimento,
        valor: valorParcela.toFixed(2),
        obs: '', // Adicione um campo para a observação
      });

    });

    setResultado(parcelas);
  };


  const handleEditarObservacao = (numeroParcela, novaObservacao) => {
    const novasParcelas = resultado.map((parcela) =>
      parcela.numero === numeroParcela ? { ...parcela, obs: novaObservacao } : parcela
    );
    setResultado(novasParcelas);
  };


  const handleExcluirParcela = (numeroParcela) => {
    const novasParcelas = resultado.filter((parcela) => parcela.codigo !== numeroParcela);
    setResultado(novasParcelas);

    // Recalcular total da compra
    const novoTotal = novasParcelas.reduce((acumulado, parcela) => acumulado + parseFloat(parcela.valor), 0);
    setTotalCompra(novoTotal.toFixed(2));
  };


  return totalCompraProp ? (
    <div>
      <div className="row mb-3">
        <div className="col-md-6">
          <label htmlFor="diasParcelas" style={{ color: '#999999' }} className="form-label">
            Dias para as Parcelas (separados por vírgula):
          </label>
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              id="diasParcelas"
              value={diasParcelas}
              onChange={(e) => setDiasParcelas(e.target.value)}
              size={'sm'}
            />
            <button
              className="btn btn-primary"
              type="button"
              onClick={calcularParcelas}
            >
              Calcular Parcelas
            </button>
          </div>
        </div>
      </div>

      <div className="mt-4">
        <h5>Parcelas:</h5>
        <table className="table table-sm">
          <thead>
            <tr>
              <th>Parcela</th>
              <th>Vencimento</th>
              <th>Valor</th>
              <th>Anotações</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {resultado.map((parcela) => (
              <tr key={parcela.codigo}>
                <td>{parcela.numero}</td>
                <td>{parcela.dataVencimento?.toLocaleDateString()}</td>
                <td>R$ {parcela.valor}</td>
                <td>
                  <input
                    type="text"
                    value={parcela.obs}
                    onChange={(e) => handleEditarObservacao(parcela.numero, e.target.value)}
                    className="form-control"
                    size={'sm'}
                  />
                </td>
                <td>
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => handleExcluirParcela(parcela.codigo)}
                  >
                    Excluir
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="mt-4">
        <p>Total da Compra: R$ {totalCompra}</p>
      </div>
    </div>
  ) : null;
})


export default CalcularParcelas;
